const algoliaAppId = 'LBNDCDUZEB'
const algoliaApiKey = '7e94e5f52d3050b349b96b187bf57abc'
const productSearchIndex = '_product_search'
const productSearchSuggestionsIndex = 'product_search_query_suggestions'
const partnerShopSearchIndex = '_partner_shop_search'

export {
  algoliaAppId,
  algoliaApiKey,
  productSearchIndex,
  productSearchSuggestionsIndex,
  partnerShopSearchIndex,
}
